import React, { useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faReceipt,
  faCloudUploadAlt,
  faList,
  faFileInvoice,
  faLock,
  faBox,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import UserContext from "../contexts/UserContext";
import BillUpload from "../components/bills/BillUpload";
import BillList from "../components/bills/BillList";
import BillDetail from "../components/bills/BillDetail";
import BillProductSearch from "../components/bills/BillProductSearch";
import BillMonthlyView from "../components/bills/BillMonthlyView";
import "./BillManagement.css";

const BillManagement = () => {
  const { user } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState("upload");
  const [selectedBillId, setSelectedBillId] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const isAdminUser = () => {
    return user && user.role === "admin";
  };

  const handleUploadSuccess = (response) => {
    // Switch to list view and refresh
    setActiveTab("list");
    setRefreshTrigger((prev) => prev + 1);

    // Optionally, auto-select the newly uploaded bill
    if (response.bill_id) {
      setSelectedBillId(response.bill_id);
      setActiveTab("detail");
    }
  };

  const handleSelectBill = (billId) => {
    setSelectedBillId(billId);
    setActiveTab("detail");
  };

  const handleBillUpdate = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  const handleCloseBillDetail = () => {
    setSelectedBillId(null);
    setActiveTab("list");
  };

  return (
    <div className="bill-management-container">
      {isAdminUser() ? (
        <>
          {/* Header */}
          <div className="bill-management-header">
            <div className="header-content">
              <h1>
                <FontAwesomeIcon icon={faReceipt} /> Bill Management
              </h1>
              <p>
                Upload, view, and manage your bills with AI-powered extraction
              </p>
            </div>
          </div>

          {/* Navigation Tabs */}
          <div className="bill-management-tabs">
            <button
              className={`tab-btn ${activeTab === "upload" ? "active" : ""}`}
              onClick={() => setActiveTab("upload")}
            >
              <FontAwesomeIcon icon={faCloudUploadAlt} /> Upload Bill
            </button>
            <button
              className={`tab-btn ${activeTab === "list" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("list");
                setSelectedBillId(null);
              }}
            >
              <FontAwesomeIcon icon={faList} /> View Bills
            </button>
            <button
              className={`tab-btn ${activeTab === "products" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("products");
                setSelectedBillId(null);
              }}
            >
              <FontAwesomeIcon icon={faBox} /> Product Search
            </button>
            <button
              className={`tab-btn ${activeTab === "monthly" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("monthly");
                setSelectedBillId(null);
              }}
            >
              <FontAwesomeIcon icon={faCalendarAlt} /> Monthly View
            </button>
            {selectedBillId && (
              <button
                className={`tab-btn ${activeTab === "detail" ? "active" : ""}`}
                onClick={() => setActiveTab("detail")}
              >
                <FontAwesomeIcon icon={faFileInvoice} /> Bill Details
              </button>
            )}
          </div>

          {/* Content Area */}
          <div className="bill-management-content">
            {activeTab === "upload" && (
              <BillUpload onUploadSuccess={handleUploadSuccess} />
            )}

            {activeTab === "list" && (
              <BillList
                onSelectBill={handleSelectBill}
                refreshTrigger={refreshTrigger}
              />
            )}

            {activeTab === "products" && (
              <BillProductSearch onSelectBill={handleSelectBill} />
            )}

            {activeTab === "monthly" && (
              <BillMonthlyView onSelectBill={handleSelectBill} />
            )}

            {activeTab === "detail" && selectedBillId && (
              <BillDetail
                billId={selectedBillId}
                onClose={handleCloseBillDetail}
                onUpdate={handleBillUpdate}
              />
            )}
          </div>
        </>
      ) : (
        <div className="access-denied-container">
          <div className="access-denied-card">
            <div className="access-denied-icon">
              <FontAwesomeIcon icon={faLock} />
            </div>
            <h2>Access Denied</h2>
            <p>Administrator privileges required to access Bill Management</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default BillManagement;
